const widgetSizeSmaller = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m8 8.4 3.54 3.677H8.842V13.9H7.2v-1.823H4.46zM8.843 2l-.001 2h2.698L8 7.677 4.46 4H7.2V2z"/></svg>',
};

export { widgetSizeSmaller as default };
